module.exports = __webpack_public_path__ + "img/image163.1ecc0c98.jpg";